import React, { useState } from "react";
import { BookOpen, ChevronDown, ChevronUp, GraduationCap, GraduationCapIcon, HelpCircle, MessageCircle, MessageCircleMore, MessageCircleQuestionIcon, Shield } from "lucide-react";
import { IoShieldCheckmark, IoShieldCheckmarkOutline } from "react-icons/io5";
import { WhatsappIcon } from "react-share";
import { FaWhatsapp } from "react-icons/fa";

const Support = () => {
const [activeIndex, setActiveIndex] = useState(0);
const [openSection, setOpenSection] = useState(1);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const data = [
    {
      title: "What is Adhyayi?",
      content:
        "Adhyayi is a learning and assessment platform designed for students preparing for Government Exams like SSC, Banking, Railway, and other competitive exams. Users can practice questions, participate in educational activities, track performance, and improve their preparation journey.",
    },
    {
      title: "How can I start learning on Adhyayi?",
      content:
        "Create your account using Mobile OTP or Google Sign-In.\nChoose your preferred exam category.\nStart practicing quizzes, mock tests, and learning activities.\nTrack your performance and progress from your dashboard.",
    },
    {
      title: "Is Adhyayi free or paid?",
      content:
        "Adhyayi offers both free and premium learning features. Some quizzes, plans, and advanced preparation modules may require access enrollment.",
    },
    {
      title: "How do I create and verify my account?",
      content:
        "You can create your account using Mobile OTP verification or Google Sign-In. Additional verification may be required for certain platform features.",
    },
    {
      title: "What are Credits on Adhyayi?",
      content:
        "Credits are in-app digital units used within the Adhyayi platform for accessing learning activities, contests, and platform features. Credits may be get through participation and platform engagement.",
    },
    {
      title: "How can I track my performance?",
      content:
        "You can monitor your quiz scores, rankings, accuracy, streaks, and activity history directly from your dashboard.",
    },
    {
      title: "Is my data secure on Adhyayi?",
      content:
        "Yes. User information is securely processed and protected using industry-standard security practices in accordance with our Privacy Policy.",
    },
  ];
  const data2 = [
    {
      title: "How do contests work on Adhyayi?",
      content:
        "Users can participate in skill-based educational contests and quizzes available on the platform. Rankings are automatically generated based on quiz performance and contest rules.",
    },
    {
      title: "How is performance calculated?",
      content:
        "Performance may be calculated based on:\n\nCorrect answers\nAccuracy\nTime taken\nContest-specific rules",
    },
    {
      title: "How are rankings decided?",
      content:
        "Rankings are automatically generated by the system using score, accuracy, response time, and contest participation rules.",
    },
    {
      title: "What are Credits used for?",
      content:
        "Credits can be used within the platform for accessing contests, quizzes, learning activities, and selected platform features.",
    },
    {
      title: "When are Credits added to my account?",
      content:
        "Eligible Credits are generally processed after activity evaluation or result declaration, depending on the specific contest or activity.",
    },
    {
      title: "Why was my activity or result not accepted?",
      content:
        "Possible reasons may include:\n\nViolation of contest rules\nMultiple attempts\nIncomplete submission\nSuspicious or unfair activity detection",
    },
    {
      title: "Can I participate multiple times?",
      content:
        "Participation limits depend on the specific activity or contest rules. Some contests may allow only one attempt.",
    },
  ];
  const data3 = [
    {
      title: "What is the difference between purchased and Reward Credits?",
      content:
        "Purchased Credits are added through platform payments and are intended for platform activities. Earned Credits may be received through eligible participation and platform engagement.",
    },
    {
      title: "Can all Credits be withdrawn?",
      content:
        "No. Certain Credits, including purchased or promotional Credits, may be restricted for platform use only, as described in the applicable activity or wallet rules.",
    },
    {
      title: "How long does withdrawal processing take?",
      content:
        "Eligible withdrawal requests are generally processed within 24-48 working hours, subject to verification and platform policies.",
    },
    {
      title: "Why is my withdrawal pending?",
      content:
        "Withdrawals may remain pending due to account verification checks, incorrect payment details, security review, or high processing volume.",
    },
    {
      title: "Is KYC required for withdrawals?",
      content:
        "Yes. Identity verification may be required before enabling certain account or withdrawal-related features.",
    },
  ];
  const data4 = [
    {
      title: "Why is account verification required?",
      content:
        "Verification helps maintain platform security, prevent misuse, and ensure a trusted learning environment for all users.",
    },
    {
      title: "What documents may be required?",
      content:
        "Depending on platform requirements, users may be asked to provide valid government-issued identification documents for verification purposes.",
    },
    {
      title: "How long does verification take?",
      content:
        "Verification is generally completed within a few hours to 1-2 working days.",
    },
    {
      title: "What should I do if verification fails?",
      content:
        "Please re-upload clear and valid documents that match your account information.",
    },
    {
      title: "Is my verification data safe?",
      content:
        "Yes. Verification data is securely encrypted and processed according to our Privacy Policy.",
    },
  ];
  const Section = ({
  title,
  subtitle,
  icon,
  data,
  index,
  openSection,
  setOpenSection,
  activeIndex,
  toggle,
}) => {
  const isOpen = openSection === index;

  return (
    <div className="bg-[#f3ecfa] rounded-2xl p-4 shadow-sm border-2 border-purple-500 mb-4">
      
      {/* Header */}
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() =>
          setOpenSection(isOpen ? null : index)
        }
      >
        <div className="flex items-center gap-3">
          
          {/* Icon Circle */}
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-bgBlue">
            {icon}
          </div>

          <div>
            <h2 className="font-semibold text-bgBlue">
              {title}
            </h2>
            <p className="text-xs text-gray-500">
              {subtitle}
            </p>
          </div>
        </div>

        {isOpen ? (
          <ChevronUp className="text-orange-500" />
        ) : (
          <ChevronDown className="text-orange-500" />
        )}
      </div>

      {/* Content */}
      {isOpen && (
        <div className="mt-3 space-y-2">
          {data.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-gray-200"
            >
              <div
                onClick={() => toggle(i)}
                className="flex justify-between items-center p-3 cursor-pointer"
              >
                <p className="text-sm font-medium text-gray-700">
                  {item.title}
                </p>

                {activeIndex === i ? (
                  <ChevronUp size={18} />
                ) : (
                  <ChevronDown size={18} />
                )}
              </div>

              {activeIndex === i && (
                <div className="px-3 pb-3 text-xs text-gray-500">
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

  return (
    <div className="min-h-screen p-4">
      {/* Header */}
     <h1 className="flex items-center gap-2 text-lg font-semibold text-gray-700 mb-4">
  <HelpCircle size={20} />
  <span>Support</span>
</h1>
<Section
  title="General"
  subtitle="Getting started & account help"
  icon={<HelpCircle size={18} />}
  data={data}
  index={1}
  openSection={openSection}
  setOpenSection={setOpenSection}
  activeIndex={activeIndex}
  toggle={toggle}
/>

<Section
  title="Contests & Performance"
  subtitle="Quizzes, rankings & credits"
  icon={<GraduationCap size={18} />}
  data={data2}
  index={2}
  openSection={openSection}
  setOpenSection={setOpenSection}
  activeIndex={activeIndex}
  toggle={toggle}
/>

<Section
  title="Credits & Withdrawals"
  subtitle="Credits usage & account processing"
  icon={<IoShieldCheckmarkOutline size={18} />}
  data={data3}
  index={3}
  openSection={openSection}
  setOpenSection={setOpenSection}
  activeIndex={activeIndex}
  toggle={toggle}
/>

<Section
  title="KYC & Verification"
  subtitle="Identity verification & security"
  icon={<IoShieldCheckmarkOutline size={18} />}
  data={data4}
  index={4}
  openSection={openSection}
  setOpenSection={setOpenSection}
  activeIndex={activeIndex}
  toggle={toggle}
/>

<div className="bg-[#F5A623] rounded-2xl p-3 mt-6 mb-10 text-[#4B2D83] text-left">
  
  <h2 className="text-lg font-bold mb-2">
    Still need help?
  </h2>

  <p className="text-md mb-2">
    Our dedicated support team is available 24/7 to assist you
  </p>

  <div className="flex justify-center gap-3">

  {/* Email Button */}
  <button className="flex-1 flex lg:flex-none lg:w-40 items-center justify-center gap-1 bg-[#4B2D83] text-white py-1 px-4 rounded-xl font-sm">
    <MessageCircleMore size={18} />
    <span>Support Email</span>
  </button>

  {/* WhatsApp Button */}
  <button className="flex items-center justify-center gap-2 bg-[#47EA43] text-white py-1 px-4 lg:w-44 rounded-xl text-sm font-medium">
  <FaWhatsapp size={18} />
  <span>Live Chat (WhatsApp)</span>
</button>

</div>
</div>

    </div>
  );
};

export default Support;
